import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import MovieClipUtil from "../../util/MovieClipUtil";

export default class ConversationTeaserPanelMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
    }

    async initialize() {
        super.initialize();

        this._slice9Panel = new Slice9Panel(this._target, MovieClipUtil.getFirstBitmapChild(this._target), {
            mode: Slice9Panel.VERTICAL,
            cacheBitmap: true,
            overlap: false,
            pixelPerfect: true,
        });

        this._target.initialY = this._target.y;
        this._target.hideY = this._target.initialY + ConversationTeaserPanelMediator.HIDE_Y_OFFSET;
    }

    setTitle(value) {
        this._target.titleTextField.text = value;
        this._slice9Panel.update();
    }

    setDescription(value) {
        this._target.descriptionTextField.text = value;
        this._slice9Panel.update();
    }

    async show() {
        this._target.visible = true;
        await createjs.Tween.get(this._target, { override: true })
            .to({
                alpha: 1,
                y: this._target.initialY,
            }, 450, createjs.Ease.sineOut)
            .toPromise();
    }

    async hide() {
        await createjs.Tween.get(this._target, { override: true })
            .to({
                alpha: 0,
                y: this._target.hideY,
            }, 250, createjs.Ease.sineIn)
            .toPromise();
        this._target.visible = true;
    }

    hideInstant() {
        this._target.visible = false;
        this._target.alpha = 0;
        this._target.y = this._target.hideY;
    }
}

ConversationTeaserPanelMediator.HIDE_Y_OFFSET = 20;